import { render, staticRenderFns } from "./campManagement.vue?vue&type=template&id=608e0204&scoped=true&"
import script from "./campManagement.vue?vue&type=script&lang=js&"
export * from "./campManagement.vue?vue&type=script&lang=js&"
import style0 from "./campManagement.vue?vue&type=style&index=0&id=608e0204&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e0204",
  null
  
)

export default component.exports